<template>
  <div v-show="showOffcanvas">
    <div :class="['offcanvas offcanvas-right offcanvas-custom notification-modal', { 'offcanvas-on' : show, 'offcanvas-off' : !show }]">

      <b-form class="d-flex flex-column h-100"
              @submit.stop.prevent="confirm">
        <div class="d-flex flex-column h-100">
          <!--begin::Header-->
          <div class="offcanvas-header d-flex align-items-center justify-content-between p-5">
            <h3 class="font-weight-bold m-0">
              {{$t('global.notifications')}}
            </h3>
            <a href="#"
               class="d-flex btn btn-xs btn-light p-2 rounded-sm sidebar_close"
               @click="close">
              <i class="far fa-times-circle p-0"></i>
            </a>
          </div>
          <!--end::Header-->

          <div>
            <div class="offcanvas-content pt-5">
              <perfect-scrollbar class="offcanvas-content pr-5 mr-n5 scroll"
                                 style="height: calc(100vh - 150px); position: relative">

                <div v-if="items && items.length > 0">

                  <div class="row px-5">
                    <div class="col-6">
                      <a class="read-button d-flex align-items-center justify-content-center"
                         @click="makeAsAllRead()"
                         :disabled="!isAnyUnread">
                        <i class="far fa-eye"></i>
                        {{$t('global.makeRead')}}
                      </a>
                    </div>
                    <div class="col-6">
                      <a class="delete-button d-flex align-items-center justify-content-center"
                         @click="removeAll()">
                        <i class="fas fa-trash"></i>
                        {{$t('global.deleteAll')}}
                      </a>
                    </div>
                  </div>

                  <div class="d-flex align-items-center notification-item px-5"
                       v-for="(item, index) in items"
                       :key="index">
                    <div class="read-icon"
                         v-if="item.isRead==false"
                         @click="makeAsRead(index)"></div>

                    <div :class="[`notification-type ${item.type}`]"><i :class="getIconType(item.type)"></i></div>
                    <div class="d-flex flex-column mx-3">
                      <div class="message"
                           v-html="item.content"></div>
                      <div class="date">{{item.date}}</div>
                    </div>
                    <div class="delete-icon"
                         @click="remove(index)">
                      <i class="fad fa-trash"></i>
                    </div>

                  </div>
                </div>
                <div v-else>
                  <div class="row px-5">
                    <div class="col-12">
                      {{$t('global.noNotificationToDisplay')}}
                    </div>
                  </div>
                </div>
              </perfect-scrollbar>
            </div>
          </div>
        </div>

      </b-form>
    </div>
    <div class="offcanvas-overlay"
         v-if="show"
         @click="close"></div>
  </div>
</template>

<script>
export default {
  name: 'NotificationModal',
  props: {
    show: Boolean,
  },
  data() {
    return {
      showOffcanvas: false,
      items: [
        {
          isRead: false,
          type: 'success',
          content:
            '<b>“VM 1”</b> İsmindeki server başarılı bir şekilde kurulmuştur',
          date: '12.02.2020 - 13:02',
        },
        {
          isRead: true,
          type: 'success',
          content:
            '<b>“VM 2 Deneme”</b> İsmindeki server başarılı bir şekilde kurulmuştur',
          date: '11.02.2020 - 13:02',
        },
        {
          isRead: true,
          type: 'error',
          content: 'Sunucularınızdan <b>“VM2”</b> de bir hata oluştu',
          date: '10.02.2020 - 14:08',
        },
        {
          isRead: true,
          type: 'info',
          content: 'Sistemlerimize bakım yapılacaktır. Bilginize.',
          date: '09.02.2020 - 14:08',
        },
        {
          isRead: true,
          type: 'continue',
          content: 'Sistem kurulumu devam etmektedir.',
          date: '08.02.2020 - 14:08',
        },
      ],
    }
  },
  computed: {
    isAnyUnread() {
      return this.items.filter((f) => f.isRead == false).length > 0
    },
  },
  created() {
    this.setShowOffcanvas()
  },
  methods: {
    setShowOffcanvas() {
      setTimeout(() => {
        this.showOffcanvas = true
      }, 1000)
    },
    close() {
      this.$emit('closeDetail', false)
    },
    makeAsRead(index) {
      this.items[index].isRead = true
    },
    makeAsAllRead() {
      this.items.map((f) => (f.isRead = true))
    },
    remove(index) {
      this.items.splice(index, 1)
    },
    removeAll() {
      this.items = []
    },
    getIconType(type) {
      switch (type) {
        case 'success':
          return 'fa fa-check'
          break
        case 'error':
          return 'fas fa-exclamation-triangle'
          break
        case 'info':
          return 'fas fa-user-headset'
          break
        case 'continue':
          return 'fas fa-sync'
          break
      }
    },
  },
}
</script> 

<style lang="scss" scoped>
.notification-modal {
  .read-button {
    background: #e1e9ff;
    border-radius: 6px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #3699ff;
    padding: 8px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
      text-decoration: none;
    }
    i {
      font-size: 12px;
      line-height: 18px;
      color: #3699ff;
      margin-right: 10px;
    }
  }
  .delete-button {
    background: #f3f6f9;
    border-radius: 6px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #f64e60;
    padding: 8px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
      text-decoration: none;
    }
    i {
      font-size: 12px;
      line-height: 18px;
      color: #f64e60;
      margin-right: 10px;
    }
  }
  .notification-item {
    position: relative;
    border-bottom: 1px solid #e5eaee;
    padding: 20px 20px 20px 0px;
    .read-icon {
      background: #ffa800;
      box-sizing: border-box;
      border-radius: 100px;
      width: 10px;
      height: 10px;
      padding: 5px;
      position: absolute;
      z-index: 99;
      cursor: pointer;
    }
    .notification-type {
      margin-left: 15px;
      padding: 10px;
      border-radius: 4px;
      display: flex;
      text-align: center;
      i {
        font-size: 20px;
        line-height: 20px;
      }
      &.success {
        background: #eee5ff;
        i {
          color: #3699ff;
        }
      }
      &.error {
        background: #ffe2e5;
        i {
          color: #f64e60;
        }
      }
      &.info {
        background: #fff4de;
        i {
          color: #ffa800;
        }
      }
      &.continue {
        background: #c9f7f5;
        i {
          color: #1bc5bd;
          animation: rotation 4s infinite linear;
        }
      }
    }
    .message {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
      color: #6c7293;
    }
    .date {
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 19px;
      color: #b5b5c3;
    }
    .delete-icon {
      display: none;
    }
    &:hover {
      .delete-icon {
        display: inherit;
        position: absolute;
        z-index: 99;
        cursor: pointer;
        right: 20px;
        i {
          color: #f64e60;
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>